const deleteServiceTypes = {
  toastr: 'Service Type Deleted',
  toastr1: ' successfully deleted'
};

export default deleteServiceTypes;
